import {DateType, JacksonType, JsonIdentityInfo} from "@sonner/jackson-service-v2";
import {SonnerBaseEntity} from "../modules/core/classes/sonner.base.entity";
import {Municipio} from "./municipio";
import {Pessoa} from "./pessoa";
import {NotaFiscal} from "./nota.fiscal";
import {ConfigNotaPremiadaPeriodo} from "./config.nota.premiada.periodo";
import {BilheteNotaPremiadaDependencia} from "./bilhete.nota.premiada.dependencia";

@JacksonType("BilheteNotaPremiada")
@JsonIdentityInfo()
export class BilheteNotaPremiada extends SonnerBaseEntity {

  id: number;

  @JacksonType("Municipio")
  municipio: Municipio;

  @JacksonType("Pessoa")
  contribuinte: Pessoa;

  numero: number;

  @JacksonType("ConfigNotaPremiadaPeriodo")
  configNotaPremiadaPeriodo: ConfigNotaPremiadaPeriodo;

  @JacksonType("NotaFiscal")
  notaFiscal:NotaFiscal;

  @JacksonType("BilheteNotaPremiadaDependencia")
  notaPremiadaDependencias: BilheteNotaPremiadaDependencia[];

  @DateType()
  dataCancelamento: Date;

  motivoCancelamento: string;

}
